import React, { Component } from 'react';

import { Auth } from '../../../support';
import UserProfile from './ReceptorUserProfile';

class ReceptorProfile extends Component {

  handleOnUserProfileUpdate = (response) => {
    const { livemode, data} = response;
    const prev = Auth.getData();

    Auth.setData({
      ...prev,
      user: {
        ...data,
        live: livemode
      }
    });
  }

  componentDidMount() {
    window.setAppTitle('Perfil');
  }

  render() {
    return (
      <>
        <UserProfile
          onComplete={ this.handleOnUserProfileUpdate }
        />
      </>
    )
  }
}

export default ReceptorProfile;